import { IFontWeight } from 'theme';

// Standard font weights
export const light: IFontWeight = 100;
export const semilight: IFontWeight = 300;
export const regular: IFontWeight = 400;
export const semibold: IFontWeight = 500;
export const bold: IFontWeight = 700;
